import React from 'react';
import { ErrorMessage, Field, FieldProps, Form, Formik, FormikHelpers, FormikProps } from 'formik';
import { Button, FormField, Label } from '@round/ui-kit';
import * as yup from 'yup';
import styles from './SongCollectionForm.module.css';
import FileUpload from '../../../../../ui/DataEntry/FileUpload/FileUpload';
import FileUploadImagePreview from '../../../../../ui/DataEntry/FileUpload/FileUploadImagePreview/FileUploadImagePreview';

type SongCollectionFormValues = {
    name: string;
    image: File[];
};

export type SongCollectionFormProps = {
    handleSubmit: (values: SongCollectionFormValues, helpers: FormikHelpers<SongCollectionFormValues>) => void;
    initialValues?: SongCollectionFormValues;
    renderActions?: (props: FormikProps<SongCollectionFormValues>) => React.ReactNode;
    imageLoading?: boolean;
};

const defaultInitialValues: SongCollectionFormValues = {
    name: '',
    image: [],
};

const defaultRenderActions: SongCollectionFormProps['renderActions'] = ({ submitForm, isSubmitting, isValid }) => (
    <Button
        className={styles.submitButton}
        type="filled"
        color="black"
        onClick={submitForm}
        loading={isSubmitting}
        disabled={!isValid}
    >
        Submit
    </Button>
);

const validationSchema = yup.object({
    name: yup.string().required('Name is required'),
});

const SongCollectionForm = ({
    handleSubmit,
    renderActions = defaultRenderActions,
    initialValues = defaultInitialValues,
    imageLoading,
}: SongCollectionFormProps) => {
    return (
        <Formik
            enableReinitialize
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
        >
            {(props) => (
                <>
                    <Form className={styles.form}>
                        <FormField>
                            <Label htmlFor="name">Name</Label>
                            <Field id="name" name="name" placeholder="Enter name" />
                            <ErrorMessage name="name">
                                {(msg) => <span className={styles.error}>{msg}</span>}
                            </ErrorMessage>
                        </FormField>

                        <FormField>
                            <Label htmlFor="image">Image</Label>
                            <Field name="image">
                                {(props: FieldProps<SongCollectionFormValues['image']>) => (
                                    <FileUpload
                                        loading={imageLoading}
                                        files={props.field.value}
                                        onUpload={(files) => props.form.setFieldValue(props.field.name, files)}
                                    >
                                        {({ files: [image] }) => (
                                            <FileUploadImagePreview className={styles.imagePreview} file={image} />
                                        )}
                                    </FileUpload>
                                )}
                            </Field>
                        </FormField>
                    </Form>
                    {renderActions(props)}
                </>
            )}
        </Formik>
    );
};

export default SongCollectionForm;
